module.exports = __webpack_public_path__ + "img/logo_FE_Inteligentny_Rozwoj_rgb-1.b4ec2ba7.webp";